"use strict";
/*
 * Created on 10 11 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Support for caching values with respect to lastModified date of source of values. Instance of the class have sole method `get`
 * that either returns cached value or runs provided `producer` function to calculate the value. Decision when produce data
 * or return then is made based on return value of second provided function `lastModified` which should return last modification
 * date of "source" of the value.
 * The class also handles situations when value is requested during value "provisioning" - value is returned once provided,
 * superfluous provisioning call is not made.
 *
 * @author Stepan Mik
 */

var CachedValue =
/*#__PURE__*/
function () {
  function CachedValue(lastModified, provider) {
    _classCallCheck(this, CachedValue);

    this.lastModified = lastModified;
    this.provider = provider;
    this.hasValue = false;
    this.modified = 0;
  }

  _createClass(CachedValue, [{
    key: "getWithLm",
    value: function getWithLm(lm) {
      var _this = this;

      if (lm < 0) {
        lm = 0;
      }

      if (this.hasValue) {
        if (lm <= this.modified) {
          return Promise.resolve(this.value);
        } else {
          return this.retrieve(lm);
        }
      } else {
        if (this.retrieving) {
          return this.retrieving.then(function () {
            return _this.get();
          });
        } else {
          return this.retrieve(lm);
        }
      }
    }
  }, {
    key: "retrieve",
    value: function retrieve(lm) {
      var _this2 = this;

      this.hasValue = false;
      this.retrieving = this.provider().then(function (v) {
        _this2.hasValue = true;
        _this2.retrieving = null;
        _this2.modified = lm;
        _this2.value = v;
        return v;
      });
      return this.retrieving;
    }
  }, {
    key: "get",
    value: function get() {
      var _this3 = this;

      var lm = this.lastModified();

      if (typeof lm === 'number') {
        return this.getWithLm(lm);
      } else {
        return lm.then(function (l) {
          return _this3.getWithLm(l);
        });
      }
    }
    /**
     * Invalidates the cache causing next get() call to retrieve fresh data.
     */

  }, {
    key: "invalidate",
    value: function invalidate() {
      this.modified = -1;
    }
  }]);

  return CachedValue;
}();

exports.CachedValue = CachedValue;